import { render, staticRenderFns } from "./ContestGroupLink.vue?vue&type=template&id=2498c86c&"
import script from "./ContestGroupLink.vue?vue&type=script&lang=js&"
export * from "./ContestGroupLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports